import { IAuthAWS } from "./IAuthAWS";
import { IAuthFunctionalities } from "./IAuthFunctionalities";
import { ITheme } from "./ITheme";
import {disableMFA} from "../libs/cognito";


export enum AuthStatus {
  Loading,
  SignedIn,
  SignedOut
}

export interface IAuth {
  sessionInfo?: {
    username?: string;
    email?: string;
    sub?: string;
    accessToken?: string;
    refreshToken?: string;
    idToken?: string;
    role?: string;
  };
  isMultifactor?:boolean;
  globalConfig?: {
    theme?: ITheme;
    authConfig?: IAuthFunctionalities;
    config?: IAuthAWS
  };
  attrInfo?: any;
  authStatus?: AuthStatus;
  signInWithEmail?: any;
  signInWithEmailnoRedirect?: any;
  signUpWithEmail?: any;
  signInOTP?: any;
  signInOTPNotRedirec?:any,
  updatePhone?: any;
  signUpWithPhone?: any;
  signOut?: any;
  verifyCode?: any;
  getSession?: any;
  sendCode?: any;
  forgotPassword?: any;
  changePassword?: any;
  getAttributes?: any;
  setAttribute?: any;
  setAttributes?: any;
  enableMFA?: any;
  reSendCode?: any;
  sendCodeRecoverPassword?: any;
  sendMfaCode?: any;
  mfaRequired?: boolean;
  adminAddUserToGroup: (username: string, groupName:string)=>Promise<any>,
  adminListGroupsForUser?:(username: string) => Promise<any>,
  reSendMfaCode?: any;
  federatedSignIn?: any;
  rememberDevice?: any;
  forgotDevice?: any;
  signUpAdmin?: any;
  forgotPasswordToken?: any;
  storeData?: any;
  onChangePhoneSubmitted?: any;
  completeNewPassword?: any;
  setIsMultifactor?: any;
  onConfirmCodeResendCodePhone?: any;
  onConfirmCodeSubmittedPhone?: any;
  onConfirmCodeSubmitted?: any;
  reSendClinicInvite?: any;
  disableAthlete?: any;
  disableMFA?:any;
  handleRedirection?: any;
}
